import { useTransCommon } from '@/@shared/hooks/useTranslations';
import Icon from '@/Icon';
import { addLayer, deleteLayer } from '@/legacy/components/apps/ClientModalProvider';
import { clc } from '@/legacy/components/base/utils';
import styles from '@/legacy/components/modalContents/kebabModal.module.scss';
import LogoutModal, { LOGOUT_MODAL_KEY } from '@/legacy/components/modalContents/LogoutModal';
import SetLanguage from '@/legacy/components/modalContents/SetLanguage';
import { BUSINESS_ACCOUNT_MAIN_PATHNAME, _PATHNAME } from '@/legacy/constants/pathname';
import { allDataClear, useGetCurrentOwner } from '@/model/dexie/ownerDexie';
import { promiseNotNullCheck } from '@/utilities/stateTool';
import { useRouter } from 'next/navigation';
import type React from 'react';
import { useEffect, useState } from 'react';

type Props = {
	locale: string;
};

type LineProps = {
	Prefix: React.ReactNode;
	onClick: () => void;
	children: string;
	className?: string;
};

export const KEBAB_KEY = 'kebab';

const LineButton = ({ Prefix, onClick, className, children }: LineProps) => {
	return (
		<button className={clc(styles.line, className)} onClick={onClick}>
			{Prefix}
			<span className={styles.text}>{children}</span>
		</button>
	);
};

type ContextType = 'main' | 'language';

const KebabModal = ({ locale }: Props) => {
	const [type, setType] = useState<ContextType>('main');

	const current = useGetCurrentOwner();
	const route = useRouter();

	const t = useTransCommon('temp.modal');

	const handleLogout = () => {
		addLayer(
			LOGOUT_MODAL_KEY,
			<LogoutModal
				applyFn={async () => {
					route.push(_PATHNAME(locale));
					await allDataClear();
					deleteLayer(LOGOUT_MODAL_KEY);
					window.location.reload();
				}}
			/>
		);
	};

	useEffect(() => {
		console.log('🚀 ~ useEffect ~ useEffect:');

		return () => {
			deleteLayer(LOGOUT_MODAL_KEY);
			deleteLayer(KEBAB_KEY);
		};
	}, []);

	if (type === 'language') return <SetLanguage closeModal={() => setType('main')} locale={locale} />;

	return (
		<div className={styles.wrap}>
			{promiseNotNullCheck(current) && (
				<LineButton
					onClick={() => {
						route.push(BUSINESS_ACCOUNT_MAIN_PATHNAME(locale));
					}}
					Prefix={
						<div className={styles.setting}>
							<Icon className={styles.icon} color1={'#FDFDFE'} path="Setting" />
						</div>
					}
				>
					{t('setting')}
				</LineButton>
			)}

			<LineButton
				onClick={() => setType('language')}
				Prefix={<Icon className={styles.icon} color1={'#FDFDFE'} path="Action_Language_32_Default" />}
			>
				{t('languageChange')}
			</LineButton>

			{/* <LineButton
				onClick={() => {}}
				Prefix={<Icon path="Action_Report_32_Default" color1={'#FDFDFE'} className={styles.icon}></Icon>}
			>
				{t('reportIssue')}
			</LineButton> */}

			{promiseNotNullCheck(current) && (
				<>
					<hr />
					<LineButton
						onClick={handleLogout}
						Prefix={<Icon className={styles.icon} color1={'#FDFDFE'} path="Action_Logout_32_Active" />}
					>
						{t('logout')}
					</LineButton>
				</>
			)}
		</div>
	);
};

export default KebabModal;
